export const DEFAULT_LANGUAGE = 'en';
export const API_SERVER = import.meta.env.VITE_APP_API_SERVER || 'http://localhost:4000';